<template>
  <div class="tmplib-tmp-preview-root" :style="{display:isOpen?'block':'none'}">
    <div class="top">
      <video class="pre-video" controls :src="tempItem ? $handleAssetsUrl(tempItem.videoUrl):''"></video>
    </div>
    <div class="buy-use">
      <div class="left-panel">
        <span class="title">{{tempItem?tempItem.title:''}}</span>
        <div class="collect">
          <div :class="tempItem.f?'like':'dislike'" @click="favoriteClick"></div>
        </div>
      </div>

      <div class="right-panel">
        <div
          class="price"
          v-if="parseFloat(tempItem.originalPrice) > 0"
        >￥{{tempItem.originalPrice}}元</div>
        <div class="price">￥{{tempItem.price}}元</div>
        <div class="vipfree" v-if="transTempPayType(tempItem) == '1'" @click="upgradeVip">开通会员</div>
        <div class="state">
          <div
            class="buy"
            v-if="transTempPayType(tempItem) == '1'"
            @click="buyTemp"
          >立即购买</div>
          <div class="use" @click="useTemp" v-else>插入模板</div>
        </div>
      </div>
    </div>
    <div class="closebtn" @click="myclose($event)"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import transTempTypeMixin from "../../../../mixins/trans-temp-type";
export default {
  mixins: [transTempTypeMixin],
  data() {
    return {
      isOpen: true
    };
  },
  props: ["tempItem"],
  methods: {
    myclose(event) {
      this.$emit("CloseTemplibPreview");
    },
    buyTemp() {
      this.$bus.$emit("openPayTemplatePanel", this.tempItem);
    },
    useTemp() {
      //this.$emit("CloseTemplibPreview");
      this.$bus.$emit("templib-tempuse-isopen", this.tempItem);
    },
    upgradeVip() {
      //console.log('this.UserLevel this.UserLevelType',this.UserLevel , this.UserLevelType)
      if (this.UserLevelType < 1 && this.UserLevel < 1) {
        $(`<a href="${window.origin + "/workplace/vipsolo"}" target="_blank"></a>`)[0].click();
        // this.$bus.emit("FeaturesPop_vue", {
        //   name: "vipEquity",
        //   msg: "开通个人VIP，每月立享5张模板兑换券",
        //   type: 2,
        //   btnMsg: "立即开通",
        //   btnMsgLink: "/workplace/vipsolo",
        //   baiduAction: "upgradeAidubVip"
        // });
        // this.$modal.show("vipDialog", {
        //   msg: '开通个人VIP，每月立享5张模板兑换券',
        //   target: "vipsolo",
        //   type: "solo",
        // });
      } else if (this.isPersonVip) {
        $(`<a href="${window.origin + "/workplace/vip"}" target="_blank"></a>`)[0].click();
        // this.$bus.emit("FeaturesPop_vue", {
        //   name: "vipEquity",
        //   msg: "升级企业版会员，海量模板免费用",
        //   type: 2,
        //   btnMsg: "立即开通",
        //   btnMsgLink: "/workplace/vip",
        //   levelType: "vip",
        //   baiduAction: "upgradeAidubVip"
        // });
        // this.$modal.show("vipDialog", {
        //   msg: '升级企业版会员，海量模板免费用',
        //   target: "vip",
        //   type: "vip",
        // });
      }
    },
    favoriteClick() {
      const API = this.tempItem.f
        ? "/api/user/template/cancelFavorites"
        : "/api/user/template/favorites";
      this.$http
        .post(API, {
          id: this.tempItem.id
        })
        .then(({ data }) => {
          if (data.code !== 200) return;
          this.showLikesToast(this.tempItem.f ? 'unlikes' : 'likes');
          this.tempItem.f = !this.tempItem.f;
        });
    },
    showLikesToast (type = 'likes') {
      if (type === 'likes') {
        this.$message({
          message: "收藏成功",
          type: "success",
        });
      }
      if (type === 'unlikes') {
        this.$message('收藏已取消');
      }
    }
  },
  mounted() {
    //console.log(this.tempItem);
    this.$bus.on("tmplib-tmp-preview", x => {
      this.isOpen = x.isOpen;
    });
    //支付完成消息
    this.$bus.on("template.payDone", checkid => {});
  },
  computed: {
    ...mapGetters(["UserLevel", "UserLevelType", "UserMsg"])
  }
};
</script>

<style lang="scss" scoped>
.tmplib-tmp-preview-root {
  width: 100%;
  height: 100%;
  background-color: #00000055;
  position: relative;
  //border-radius: 0 4px 4px 0;
  overflow: hidden;
  .top {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: #00000080;
    .pre-video {
      margin: 42px;
      width: 1010px;
      height: 568px;
      outline: none;
    }
  }

  .buy-use {
    background-color: white;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 56px;
    .left-panel {
      height: 100%;
      float: left;
      padding: 10px;
      .title {
        float: left;
        margin: 10px;
        color: #474261;
        font-size: 14px;
      }
      .collect {
        width: 18px;
        height: 18px;
        float: left;
        margin: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        .like {
          height: 100%;
          width: 100%;
          background-image: url(../../../../../../static/svg/template-material-lib/common/like.svg);
        }
        .dislike {
          height: 100%;
          width: 100%;
          background-image: url(../../../../../../static/svg/template-material-lib/common/dislike.svg);
        }
      }
    }

    .right-panel {
      float: right;
      height: 100%;

      .price {
        margin: 19px;
        float: left;
        color: #ff3a3f;
        font-weight: bold;
        font-size: 14px;
      }
      .vipfree {
        width: 120px;
        height: 100%;
        background-color: #f8dbb2;
        color: #9b6313;
        float: left;
        padding: 20px;
      }
      .state {
        height: 100%;
        width: 120px;
        background-color: #5778fb;
        //border-radius: 0px 0px 8px 0px;
        float: left;
        color: white;
        font-size: 14px;
        .use {
          padding: 20px;
          height: 100%;
        }
        .buy {
          padding: 20px;
          height: 100%;
        }
      }
    }
  }

  .closebtn {
    position: absolute;
    height: 16px;
    width: 16px;
    top: 18px;
    right: 18px;
    background-image: url(../../../../../../static/svg/template-material-lib/common/close-1.svg);
    //background-color: aqua;
    &:hover {
      background-image: url(../../../../../../static/svg/template-material-lib/common/close-active.svg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/template/templatePreview.vue